import Box from './Box';
import Text from './Text';
import React from 'react';
import { translate } from '../locale';
import { useBooking } from '../BookingProvider';
import { formatCourseDay, formatCourseTimeRange } from '../utils/formatCourseDate';

export default function CourseItemDetail(
  {
    course,
    hideCity
  }: {
    course: any;
    hideCity?: boolean;
  }
) {
  const { locale } = useBooking();

  const isPgs = course.type === 'PGS';
  const hasThreeParts = Boolean(course.dateRange3?.start1);

  const dateRanges = [
    { key: 'dateRange1', label: 'Grundkurs 1', range: course.dateRange1 },
    { key: 'dateRange2', label: 'Grundkurs 2', range: course.dateRange2 },
    { key: 'dateRange3', label: 'Grundkurs 3', range: course.dateRange3 }
  ].filter(({ range }) => range?.start1);

  return (
    <>
      {
        isPgs &&
        <Box direction='column' paddingBottom={16}>
          <Text size={20} weight={'500'} color='red'>
            {translate(locale, 'infoMessage', hasThreeParts ? 'pgsTitle3Parts' : 'pgsTitle2Parts')}
          </Text>
        </Box>
      }
      {
        dateRanges.map(({ key, label, range }) => (
          <Box key={key} direction='column' paddingBottom={8}>
            {
              isPgs &&
              <Text weight={'500'}>{label}</Text>
            }
            <Text weight={'500'}>{formatCourseDay(range.start1)}</Text>
            <Text color='grey'>{formatCourseTimeRange(range.start1, range.end1)}</Text>
            {
              range.start2 &&
              <Text color='grey'>{formatCourseTimeRange(range.start2, range.end2)}</Text>
            }
          </Box>
        ))
      }
      {
        (isPgs && !hasThreeParts) &&
        <Box direction='column' paddingBottom={8}>
          <Text weight={'500'}>{translate(locale, 'infoMessage', 'pgs3_info')}</Text>
          <Text color='grey'>{translate(locale, 'infoMessage', course.instructorName === 'Giovanni Caruso' ? 'pgs3_caruso' : 'pgs3')}</Text>
        </Box>
      }
      {
        course.instructorName &&
        <Box direction='column'>
          <Text weight={'500'}>{translate(locale, 'infoMessage', 'instructor')}</Text>
          <Text color='grey'>{course.instructorName}</Text>
        </Box>
      }
      {
        (
          !hideCity ||
          isPgs
        ) &&
        course.address &&
        <Box direction='column' paddingTop={8}>
          <Text weight={'500'}>Ort</Text>
          {
            course.address?.name &&
            <Text color='grey'>{course.address?.name}</Text>
          }
          <Text color='grey'>{course.address?.street}, {course.address?.postCode} {course.address?.city}</Text>
        </Box>
      }
    </>
  )
}
